import { render, staticRenderFns } from "./Redefinir.vue?vue&type=template&id=8865e99a&"
import script from "./Redefinir.vue?vue&type=script&lang=js&"
export * from "./Redefinir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports